export default __webpack_public_path__ + "ac0ed81966b11706ef0efccf5e8aa574.webp";